import my_collection from "../lang/zh-tw/mine/my-collection.js";

//商品详情
import productDetail from "../lang/zh-tw/product/productDetail.js";
export default {
  my_collection: my_collection,
  productDetail: productDetail
};